import { render, staticRenderFns } from "./BoxFlowPlatForm.vue?vue&type=template&id=c8d466b4&"
import script from "./BoxFlowPlatForm.vue?vue&type=script&lang=js&"
export * from "./BoxFlowPlatForm.vue?vue&type=script&lang=js&"
import style0 from "./BoxFlowPlatForm.vue?vue&type=style&index=0&id=c8d466b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BoxFlowPlatForm.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./BoxFlowPlatForm.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QCard,QIcon,QBtn,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QIcon,QBtn,QDialog})
